import React, { useState }from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { resetPagination } from 'reducers/paginationRegistersSlice';
import { resetFilters } from 'reducers/filtersRegistersSlice'; 
import DashboardIcon from '@mui/icons-material/Dashboard'; 
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from "react-i18next"
import { useNavigate } from 'react-router-dom'; 
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import { useParams } from 'react-router-dom'; 
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Person from 'pages/main/Person';
import Messages from 'pages/messages/Messages'; 
import SendEMAILPurchaseToSystem from "pages/purchaseDelivery/purchaseCreateInicident/SendEMAILPurchaseIncidents";

const HomeSentIncidentPurchaseEditData = (typeList) => {
    const {t} = useTranslation(['listDataGeneralSettings']);
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate(); 
    const state = useSelector((state) => state);
    const enabled = state.loginUser.enabled; 
    const defaultStore = state.loginUser.defaultStore;
    const [showModalSentInicidents, setShowModalSentInicidents] = useState(true);
    const scriptUrl = '/js/sb-admin-2.min.js'; 
    const [typeOfList] = useState(typeList);
    
    const closeModalSentIncident = () => {    
        setShowModalSentInicidents(showModalSentInicidents);
        dispatch(resetPagination());
        dispatch(resetFilters());
        navigate(typeOfList==="1"?"/formdi":`/formdiended`);
        return () => {};
    };
         
    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer/>
        {enabled===false ? <Navigate to="/"></Navigate>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary toggled sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_SentInicidents')}</span></div>
                    </li> 
                   
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>
 
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalSentIncident} >
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div> 
          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                             <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>   
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}
                    <SendEMAILPurchaseToSystem  
                        id={id}
                        showModalSentInicidents={showModalSentInicidents}
                        typeOfList={typeOfList.typeList}
                    />
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

        </div>
        {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeSentIncidentPurchaseEditData;
